import type { HttpClient } from '../http/HttpClient'
import type { SocietySetting, SocietySettingValue, SocietySettingsRepository } from '@/domain/society/SocietySettings'

const URL = 'accountability/society/settings'

export class HttpSocietySettingsRepository implements SocietySettingsRepository {
  constructor(private http: HttpClient) {}

  async list(): Promise<SocietySetting[]> {
    return (await this.http.url(URL).get<{ settings: SocietySetting[] }>()).settings
  }

  async update(changes: Record<string, SocietySettingValue>): Promise<SocietySetting[]> {
    return (await this.http.url(URL).body(changes).put<{ settings: SocietySetting[] }>()).settings
  }
}
